module.exports = __webpack_public_path__ + "img/ic_yixiubao_logo.76f3ce0b.svg";